const noop = () => {};
const noopLogger = { info: noop, warn: noop, error: noop, debug: noop };

let logger = noopLogger;

if (typeof window !== 'undefined') {
  try {
    const { createBrowserLogger } = require('@zealot/monitoring/browser');
    logger = createBrowserLogger('advocate-portal');
  } catch {
    // Fallback to noop if monitoring package fails to load
  }
}

export default logger;
